export const STUDENT_WORKFLOW_TEMPLATE_CONFIG = Object.freeze({
  scheduling: Object.freeze({
    todoId: 'eb951f3adf475',
    todoName: 'Scheduling Workflow Template',
    whichList: 'scheduling',
  }),
  intro: Object.freeze({
    todoId: 'skfdhs23432432',
    todoName: 'Intro Lesson Workflow Template',
    whichList: 'intro',
  }),
  onboarding: Object.freeze({
    todoId: 'f20cf7a066ac8',
    todoName: 'Onboarding Workflow Template',
    whichList: 'onboarding',
  }),
});

export const getStudentWorkflowTemplateConfig = (column) =>
  STUDENT_WORKFLOW_TEMPLATE_CONFIG[String(column || '').trim().toLowerCase()] || null;

export const buildDefaultStudentWorkflowTemplate = (column) => {
  const config = getStudentWorkflowTemplateConfig(column);
  if (!config) return null;

  return {
    todoId: config.todoId,
    todoName: config.todoName,
    todoDescription: `Template for ${config.todoName.toLowerCase()}.`,
    familyId: '',
    studentList: [],
    todoDueDate: '',
    todoAlarm: false,
    todoOwner: 'Bri',
    whichList: config.whichList,
    whichSchool: 'all',
    todoSubtasks: [],
  };
};
